import {ReceiptInfoResultVo} from '../../common/shared/api/nicolas/vo/billing/ReceiptInfoResultVo.interface';
import {ReceiptInfoResult, ReceiptResultType} from '../generated/types';
import {receiptInfoTypeMap} from './ReceiptInfo';

export function createReceiptInfoResult({
  receipt_info_type,
  receipt_info,
  receipt_price,
  receipt_cancel_price,
  created_at,
  receipt_type,
  receipt_auth_num,
  receipt_cancel_num,
}: ReceiptInfoResultVo): ReceiptInfoResult {
  return {
    receiptInfoType: receiptInfoTypeMap[receipt_info_type],
    receiptInfo: receipt_info,
    receiptPrice: receipt_price,
    receiptCancelPrice: receipt_cancel_price,
    createdAt: created_at,
    receiptType: receiptTypeMap[receipt_type],
    receiptAuthNum: receipt_auth_num,
    receiptCancelNum: receipt_cancel_num,
  };
}

export const receiptTypeMap: {[key: string]: ReceiptResultType} = {
  '1': ReceiptResultType.Normal,
  '2': ReceiptResultType.Canceled,
};
